export const fiData = {
  title: "Tietosuoja- ja evästekäytäntö – Danghuan",
  sections: [
    {
      title: "Johdanto",
      content: `
        <p>Tämä tietosuoja- ja evästekäytäntö selittää, miten Danghuan Europe S.L. ('me', 'meitä' tai 'Danghuan') kerää, käyttää ja suojaa henkilötietojasi, kun käytät verkkosivujamme ja palveluitamme. Käytäntö koskee Euroopan talousalueen (ETA) ja Yhdistyneen kuningaskunnan (UK) asukkaita ja noudattaa EU:n yleistä tietosuoja-asetusta (GDPR) sekä Suomen tietosuojalainsäädäntöä.</p>
      `
    },
    {
      title: "Käytännön soveltamisala",
      content: `
        <p>Tämä käytäntö koskee:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Verkkosivustomme kävijöitä (https://www.danghuan.eu)</li>
          <li style='margin-bottom: 8px;'>Asiakkaita ja potentiaalisia asiakkaita</li>
          <li style='margin-bottom: 8px;'>Trade-in- ja jälleenmyyntipalveluidemme käyttäjiä</li>
          <li style='margin-bottom: 8px;'>Liikekumppaneiden ja alihankkijoiden edustajia</li>
        </ul>
      `
    },
    {
      title: "Kerättävät tiedot",
      content: `
        <p>Riippuen siitä, miten olet meihin yhteydessä, voimme kerätä seuraavia tietoja:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Koko nimi, osoite, sähköpostiosoite ja puhelinnumero</li>
          <li style='margin-bottom: 8px;'>IBAN, tilinumero, PayPal- tai Revolut-tiedot tai muut maksutiedot</li>
          <li style='margin-bottom: 8px;'>Laitteen tiedot (malli, merkki, kunto, hinta-arvio, IMEI)</li>
          <li style='margin-bottom: 8px;'>Viestintähistoria asiakaspalvelumme kanssa</li>
          <li style='margin-bottom: 8px;'>Markkinointiasetukset ja kampanjavuorovaikutukset</li>
          <li style='margin-bottom: 8px;'>IP-osoite, selaintyyppi, istuntotunnus ja sijainti</li>
          <li style='margin-bottom: 8px;'>Alustatiedot Shopifylta, Amazonilta, TEMU:lta tai Back Marketilta</li>
        </ul>
        <p>Saatamme saada tiettyjä tietoja sinusta myös yhteistyökumppaneiltamme, kuten Shopify, Amazon, Back Market tai TEMU, kun käytät heidän palveluitaan meidän tuotteidemme tai palveluidemme yhteydessä. Näitä voivat olla tilausdata, toimitusosoite ja tapahtumien tila.</p>
      `
    },
    {
      title: "Henkilötietojen käyttö",
      content: `
        <p>Käytämme tietojasi seuraaviin tarkoituksiin:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Trade-in-, myynti- tai palvelupyyntöjesi käsittely ja täyttäminen</li>
          <li style='margin-bottom: 8px;'>Yhteydenpito tilauksen tilasta, toimitus tiedoista tai tukipyynnöistä</li>
          <li style='margin-bottom: 8px;'>Asiakaspalvelumme, toiminnan tehokkuuden ja käyttäjäkokemuksen parantaminen</li>
          <li style='margin-bottom: 8px;'>Lakisääteisten velvoitteiden noudattaminen, mukaan lukien kirjanpito-, verotus- ja raportointivaatimukset</li>
          <li style='margin-bottom: 8px;'>Palveluidemme käytön analysointi ja seuranta petosten tai väärinkäytön estämiseksi</li>
          <li style='margin-bottom: 8px;'>Kampanjoista, palvelupäivityksistä tai ehtojen muutoksista viestiminen, kun se on asiaankuuluvaa ja laillista</li>
        </ul>
      `
    },
    {
      title: "Evästeet",
      content: `
        <p>Käytämme evästeitä (cookies) parantaaksemme selauskokemustasi ja kehittääksemme palvelujamme. Evästeet voivat kerätä tietoja kuten:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>IP-osoite ja sijainti</li>
          <li style='margin-bottom: 8px;'>Selaimen tai laitteen tunnisteet</li>
          <li style='margin-bottom: 8px;'>Käyttödata (sivut, viipymisaika, klikkaukset)</li>
        </ul>
        <p>Evästetyypit:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Välttämättömät evästeet</li>
          <li style='margin-bottom: 8px;'>Toiminnalliset evästeet</li>
          <li style='margin-bottom: 8px;'>Suorituskykyä mittaavat evästeet</li>
          <li style='margin-bottom: 8px;'>Mainonta- ja kohdennusevästeet</li>
        </ul>
        <p>Voit hallita tai peruuttaa evästeasetuksesi milloin tahansa selaimessasi tai evästebannerin kautta.</p>
      `
    },
    {
      title: "Tietojen jakaminen kolmansien osapuolten kanssa",
      content: `
        <p>Jaamme tietoja maksu- ja logistiikkakumppaneiden kanssa sopimusvelvoitteiden perusteella; ja analytiikkapalveluntarjoajien kanssa evästesuostumuksesi perusteella.</p>
        <p>Tietoja voidaan jakaa seuraaville:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Maksukumppanit: PayPal, Revolut, VISA, Mastercard, Stripe</li>
          <li style='margin-bottom: 8px;'>Logistiikkakumppanit: UPS, Correos, DPD, Royal Mail, NACEX, FedEx</li>
          <li style='margin-bottom: 8px;'>Alustakumppanit: Shopify, Amazon, TEMU, BackMarket</li>
          <li style='margin-bottom: 8px;'>Markkinointi- ja analytiikkakumppanit: Google, Meta, TikTok, REDnote, X (Twitter), Instagram, LinkedIn</li>
          <li style='margin-bottom: 8px;'>IT-palveluntarjoajat, konsultit ja oikeudelliset neuvonantajat</li>
          <li style='margin-bottom: 8px;'>Viranomaiset, jos laki sitä vaatii</li>
        </ul>
        <p>Tietojen siirrot ETA:n tai UK:n ulkopuolelle tapahtuvat vain EU:n vakiolausekkeisiin (SCC) tai muihin hyväksyttyihin suojauskeinoihin perustuen.</p>
      `
    },
    {
      title: "Kolmansien osapuolten brändilogojen käyttö",
      content: `
        <p>Verkkosivustomme näyttää tuotemerkkejä ja logoja, kuten Apple, Samsung, OPPO, OnePlus, VIVO, Xiaomi, Google ja muut, vain yhteensopivien laitteiden tunnistamiseksi trade-in- tai jälleenmyyntitarkoituksiin. Kaikki tavaramerkit kuuluvat niiden omistajille. Danghuan Europe on itsenäinen palveluntarjoaja eikä ole sidoksissa näihin tuotemerkkeihin, eikä niiden tuella tai sponsoroimana, ellei nimenomaisesti mainita. Näiden logojen läsnäolo ei merkitse minkäänlaista muodollista liikesuhdetta.</p>
        <p>Kolmannen osapuolen brändilogojen käyttö on ainoastaan kuvailevaa. Kaikki nämä brändit säilyttävät omat oikeutensa, eikä Danghuanin kanssa ole mitään yhteyttä.</p>
      `
    },
    {
      title: "Tietojen säilytys ja turvallisuus",
      content: `
        <p>Säilytämme tietojasi vain niin kauan kuin se on tarpeen edellä mainittuihin tarkoituksiin tai lain edellyttämällä tavalla. Käytämme asianmukaisia teknisiä ja organisatorisia toimenpiteitä suojataksemme tietojasi – mukaan lukien salaus, pääsynhallinta ja turvallinen tallennus.</p>
      `
    },
    {
      title: "Oikeutesi",
      content: `
        <p>Pyrimme vastaamaan kaikkiin päteviin tietopyyntöihin kuukauden kuluessa. Tietosuojasi suojelemiseksi saatamme joutua vahvistamaan henkilöllisyytesi ennen pyynnön käsittelyä.</p>
        <p>Sinulla on oikeus:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Saada pääsy omiin tietoihisi ja oikaista niitä</li>
          <li style='margin-bottom: 8px;'>Pyytää tietojesi poistamista ("oikeus tulla unohdetuksi")</li>
          <li style='margin-bottom: 8px;'>Vastustaa käsittelyä tai rajoittaa sitä</li>
          <li style='margin-bottom: 8px;'>Peruuttaa suostumuksesi milloin tahansa</li>
          <li style='margin-bottom: 8px;'>Pyytää tietojen siirtoa (soveltuvin osin)</li>
        </ul>
        <p>Voit käyttää näitä oikeuksia ottamalla yhteyttä osoitteeseen <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></p>
      `
    },
    {
      title: "Käytännön päivitykset",
      content: `
        <p>Voimme päivittää tätä käytäntöä vastaamaan lakimuutoksia tai sisäisiä tietosuojakäytäntöjä. Uusin versio on aina saatavilla verkkosivustollamme.</p>
      `
    },
    {
      title: "Yhteystiedot",
      content: `
        <p>Jos sinulla on kysyttävää tai haluat käyttää oikeuksiasi, ota yhteyttä:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'><strong>Danghuan Europe S.L.</strong></li>
          <li style='margin-bottom: 8px;'><strong>Sähköposti:</strong> <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></li>
          <li style='margin-bottom: 8px;'><strong>Verkkosivusto:</strong> <a href="https://www.danghuan.eu" target="_blank">https://www.danghuan.eu</a></li>
        </ul>
        <p>Voit myös tehdä valituksen paikalliselle tietosuojaviranomaisellesi tai Espanjan tietosuojavirastolle (Agencia Española de Protección de Datos – AEPD).</p>
      `
    },
    {
      title: "Liite – Laajennetut oikeudelliset ja evästetiedot",
      subsections: [
        {
          title: "1. Henkilötietojen käsittelyn oikeusperusteet",
          content: `
            <p>Henkilötietojesi käsittely perustuu:</p>
            <ul style='list-style-type: disc; padding-left: 20px;'>
              <li style='margin-bottom: 8px;'>Sopimuksen täyttämiseen (esim. trade-in-tilausten käsittely ja maksut)</li>
              <li style='margin-bottom: 8px;'>Lakisääteisiin velvoitteisiin (esim. verotus, henkilöllisyyden tarkistus)</li>
              <li style='margin-bottom: 8px;'>Suostumukseesi (esim. markkinointi tai kolmannen osapuolen evästeet)</li>
              <li style='margin-bottom: 8px;'>Oikeutettuun etuumme (esim. petosten estäminen, palveluiden kehittäminen)</li>
            </ul>
          `
        },
        {
          title: "2. Petosten ehkäisy",
          content: `
            <p>Voimme käyttää henkilötietojasi (esim. laitteen sarjanumero, tapahtumamalli, IP-sijainti, IBAN-tilinomistus) petosten tunnistamiseen hyödyntämällä julkisia tietokantoja ja petostentorjuntapalveluita. Tämä perustuu oikeutettuun etuumme estää identiteettivarkaudet ja palveluidemme väärinkäyttö.</p>
            <p>Emme tee päätöksiä, jotka perustuvat yksinomaan automaattiseen käsittelyyn ja joilla olisi merkittäviä vaikutuksia sinuun.</p>
          `
        },
        {
          title: "3. Tietojen käsittely ulkoisilla markkinapaikoilla",
          content: `
            <p>Jos ostat tai myyt laitteita kolmannen osapuolen alustoilla, kuten Amazon, Shopify, TEMU tai Back Market, Danghuan voi vastaanottaa tilaus- ja maksutietoja salattujen rajapintojen (API) kautta vain tilausten täyttämistä ja asiakastukea varten.</p>
          `
        },
        {
          title: "4. Evästeluokat ja yksityiskohdat",
          content: `
            <p>Voit tarkistaa täydellisen luettelon käyttämistämme evästeistä – mukaan lukien nimi, palveluntarjoaja, tarkoitus, kesto ja tyyppi (ensimmäisen tai kolmannen osapuolen eväste) – alla olevasta taulukosta. Tähän sisältyvät mm. Google Analyticsin analytiikkaevästeet, Metan uudelleenkohdennusevästeet sekä PayPalin maksuevästeet.</p>
            <table style='border-collapse: collapse; width: 100%;'>
              <thead>
                <tr>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Luokka</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Evästeen nimi</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Tarjoaja</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Tarkoitus</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Kesto</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Tyyppi</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Välttämätön</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>OptanonConsent</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tallentaa evästeasetukset</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 vuosi</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Ensimmäinen osapuoli</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Välttämätön</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>session_id</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Ylläpitää istunnon tilaa sivujen välillä</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Istunto</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Ensimmäinen osapuoli</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Toiminnallinen</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>i18next</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Muistaa valitun kieliasetuksen</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Istunto</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Ensimmäinen osapuoli</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Toiminnallinen</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>live_chat</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tawk.to</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Mahdollistaa live-chat-tuen</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>6 kuukautta</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Kolmas osapuoli</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Suorituskyky</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_ga</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Analytics</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Kerää sivuston käyttötilastoja</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>2 vuotta</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Kolmas osapuoli</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Suorituskyky</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_gid</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Analytics</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Seuraa käyttäjän käyttäytymistä istuntojen välillä</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>24 tuntia</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Kolmas osapuoli</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Suorituskyky</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_clck</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Microsoft Clarity</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Ylläpitää käyttäjäistuntoa sivujen välillä</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 vuosi</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Kolmas osapuoli</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Mainonta</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_fbp</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Meta (Facebook)</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Toimittaa personoituja mainoksia käyttäytymisen perusteella</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>3 kuukautta</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Kolmas osapuoli</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Mainonta</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_tt_enable_cookie</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>TikTok</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Seuraa käyttäjäinteraktioita ja konversioita</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>13 kuukautta</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Kolmas osapuoli</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Mainonta</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_uetsid</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Bing</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Seuraa käyttäjiä verkkosivustojen välillä markkinointia varten</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 päivä</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Kolmas osapuoli</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Mainonta</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_gcl_au</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Ads</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Käytetään konversioiden seurantaan</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>3 kuukautta</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Kolmas osapuoli</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Mainonta</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>__kla_id</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Klaviyo</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tunnistaa kävijät sähköpostimarkkinointikampanjoita varten</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>2 vuotta</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Kolmas osapuoli</td>
                </tr>
              </tbody>
            </table>
          `
        },
        {
          title: "5. Kampanjat, kyselyt ja arvonnat",
          content: `
            <p>Kun osallistut kampanjoihimme, kyselyihin tai arvontoihin, voimme kerätä nimesi, yhteystietosi ja tapahtumakohtaisia lisätietoja (esim. ikä, sijainti). Näitä tietoja käytetään vain kampanjan toteuttamiseen, voittajien kontaktointiin ja tulevien tapahtumien kehittämiseen.</p>
          `
        },
        {
          title: "6. Tietosuojaviranomaiset",
          content: `
            <p>Jos uskot, että tietosuojaoikeuksiasi on rikottu, voit tehdä valituksen:</p>
            <ul style='list-style-type: disc; padding-left: 20px;'>
              <li style='margin-bottom: 8px;'>Suomessa: Tietosuojavaltuutetun toimisto – <a href="https://tietosuoja.fi" target="_blank">https://tietosuoja.fi</a></li>
              <li style='margin-bottom: 8px;'>Euroopan unionissa: oman maasi tietosuojaviranomaiselle Euroopan tietosuojaneuvoston (EDPB) sivuston kautta – <a href="https://edpb.europa.eu/about-edpb/board/members" target="_blank">https://edpb.europa.eu/about-edpb/board/members</a></li>
            </ul>
          `
        }
      ]
    }
  ]
};